import '@accessible360/accessible-slick';

export const Grants = (() => {
	'use strict';

	let $grant;
	
	function init() {
		$grant = $('li.state');
		events();
		slider();
	}
	
	
	function events(){
		/*First item on load*/
		$('li.state:first-child').addClass('active');
		$('.state--grant:first-child').addClass('active');
		
		
		/*Toggle Statess open/closed*/
		$grant.click(function(){
			
			var stateAttr = $(this).data('value');
			
			$(this).addClass('active').siblings().removeClass('active');
			$('.state--grant[data-value='+ stateAttr +']').toggleClass('active').siblings().removeClass('active');
			
		});
	}

	function slider(){
		if ( !$('body').hasClass('wp-admin') ) {
			$('.state--slider').slick({
				dots: true,
				arrows: true,
				centerMode: true,
				speed: 200,
				autoplay: false,
				autoplaySpeed: 0,
				slidesToShow: 1,
				slidesToScroll: 1,
				prevArrow: "<button type='button' class='slick-btn slick-btn--prev' aria-label='Previous Grant Arrow'>Previous Grant Arrow</button>",
				nextArrow: "<button type='button' class='slick-btn slick-btn--next' aria-label='Next Grant Arrow'>Next Grant Arrow</button>"
			});
	
		}
	}
	return {
		init: init,
		name: 'grants'
	};
})();
